<template>
  <div>
    <div id="close-setting">
      <b-icon @click.native="$router.push('/settings')" class="hoverable" icon="close-circle" />
    </div>
    <h1 class="title is-4">Account</h1>
    <hr/>
    <h2 class="title is-6 mb-2">Beveiliging</h2>
    <div class="block">Stel hieronder regelmatig een nieuw wachtwoord in.</div>
    <div class="columns">
      <div class="column">
        <validation-provider class="validation-field" name="Wachtwoord" rules="min:6" v-slot="{ errors }">
          <div class="high-field">
            <b-field label="Nieuw wachtwoord">
              <b-input type="password" v-model="user.password" />
            </b-field>
            <p class="help is-danger">{{ errors[0] }}</p>
          </div>
        </validation-provider>
      </div>
      <div class="column">
        <b-field label="Herhaal wachtwoord">
          <b-input type="password" v-model="user.passwordRpt" />
        </b-field>
      </div>
    </div>
    <hr />
    <b-button :disabled="disabledSubmit" @click="savePassword()" size="is-medium" class="is-pulled-right" type="is-success">Opslaan</b-button>
  </div>
</template>
<script>
import ApiService from "@/common/api.service"

export default {
  data() {
    return {
      user: {
        password: "",
        passwordRpt: "",
      },
    }
  },
  methods: {
    async savePassword() {
      if (this.user.password !== this.user.passwordRpt) {
        return this.$buefy.toast.open({
          message: "De wachtwoorden komen niet overeen",
          type: "is-danger",
          position: "is-bottom-right",
        })
      }
      let response = await ApiService.post("user/password", {
        password: this.user.password,
      })

      this.$gtag.event("change_password", { event_category: "user", value: 1 })

      return this.$buefy.toast.open({
        message: "Je wachtwoord is veranderd",
        type: "is-success",
        position: "is-bottom-right",
      })
    },
  },
  computed: {
    disabledSubmit() {
      return this.user.password == "" || this.user.passwordRpt == ""
    },
  },
}
</script>
<style lang="scss" scoped>
#close-setting {
  display: none;
  position: absolute;
  top: 10px;
  right: 10px;
}
@media only screen and (max-width: 1200px) {
  #close-setting {
    display: block;
  }
}
</style>
